<section class="mx-auto max-w-7xl">
  <div class="flex justify-center">
    <div class="relative aspect-video w-full">
      @if (isLoading()) {
        <div
          class="absolute inset-0 animate-pulse rounded-lg bg-gray-200"
        ></div>
      }
      <video
        #videoElement
        [class]="
          'relative w-full rounded-lg shadow-lg transition-opacity duration-300' +
          (isLoading() ? ' opacity-0' : ' opacity-100')
        "
        loop
        muted
        playsinline
        (canplay)="handleVideoLoaded()"
      >
        <source [src]="src()" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</section>
